import { Badge, DotLoading, Ellipsis, InfiniteScroll, List } from "antd-mobile";
import React, { useState } from "react";

import DetailPopup from "../DetailPopup";
import ListItem from "../ListItem";

import { useTranslation } from "react-i18next";
import { useGetAnnouncementList } from "../../hooks/systemAnnoucement.hook";

function Announce() {
  const { t } = useTranslation();
  const [showDetail, setShowDetail] = useState(false);
  const [nowDetailItem, setNowDetailItem] = useState({});
  const getAnnouncementList = useGetAnnouncementList({
    getNextPageParam: (lastPage, pages) => {
      if (pages.length < lastPage.last_page) {
        return pages.length + 1;
      } else {
        return undefined;
      }
    },
  });
  const InfiniteScrollContent = ({ hasMore }) => {
    return (
      <>
        {hasMore ? (
          <>
            <DotLoading />
          </>
        ) : (
          <span>{t("mobile.infiniteScroll.bottom")}</span>
        )}
      </>
    );
  };

  return (
    <div style={{ height: "calc(100vh - 87px)", overflowY: "scroll" }}>
      <List>
        {getAnnouncementList.data?.pages?.map((page, index) => {
          return page.data.map((item, index) => {
            return (
              <ListItem
                key={item.id}
                title={item.title}
                date={item.created_at}
                onClick={() => {
                  setNowDetailItem(item);
                  setShowDetail(true);
                }}
                contentRender={() => {
                  //remove all line breaks
                  const content = item.content.replace(/(\r\n|\n|\r)/gm, "");
                  return (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Ellipsis
                        direction="end"
                        rows={2}
                        content={content}
                        style={{ paddingRight: "8px" }}
                      />
                      <Badge content={item.read_status == 0 ? Badge.dot : ""} />
                    </div>
                  );
                }}
              />
            );
          });
        })}
      </List>
      <InfiniteScroll
        loadMore={getAnnouncementList.fetchNextPage}
        hasMore={getAnnouncementList.hasNextPage}
      >
        <InfiniteScrollContent hasMore={getAnnouncementList.hasNextPage} />
      </InfiniteScroll>
      <DetailPopup
        visible={showDetail}
        onClose={() => {
          setShowDetail(false);
          setNowDetailItem({});
        }}
        detailItem={nowDetailItem}
      />
    </div>
  );
}

export default Announce;
